import React, { useEffect } from "react";
import { apiGet, apiPostPut } from "../../api/api_methods";
import { useStores } from "../../store";
import { useNavigate } from "react-router-dom";

export default function AutoLogin() {
  const { UserStore } = useStores();
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const userId = params.get("recruiterId");

    const run = async () => {
      // Get user data from localStorage (synchronous)
      const userData = await localStorage.getItem("user");
      const parsedUser = userData ? JSON.parse(userData) : null;
      const isAccountVerified = parsedUser?.isAccountVerified;
      console.log("AutoLogin Debug:", {
        userId,
        isAccountVerified,
        hasUserData: !!parsedUser,
        currentPath: window.location.pathname,
      }); // If no userId or account not verified, navigate to AccountVerification
      if (!userId && userData && !isAccountVerified) {
        console.log(
          "Navigating to AccountVerification - userId:",
          userId,
          "isAccountVerified:",
          isAccountVerified
        );
        navigate("/AccountVerification");
        return;
      }
      if (!userId) return;
      try {
        const response = await apiPostPut(
          null,
          `/user/user-with-id/${userId}`,
          "PUT"
        );
        if (response.status === 200 && response?.body?.data) {
          const user = response.body.data;
          localStorage.setItem("user", JSON.stringify(user));
          if (UserStore?.setUserDetails) {
            UserStore.setUserDetails(user);
          }
          //   const url = window.location.href;
          //   const newUrl = url.replace("recruiterId", "userId");
          //   window.history.replaceState(null, "", newUrl);
          //   window.location.reload();
        }
      } catch (e) {
      } finally {
        // Clean the userId from the URL without reloading the page
        try {
          if (!UserStore.userDetails?.isAccountVerified) {
            // setIsAccountVerified(true);
            navigate("/AccountVerification");
          }
          const newParams = new URLSearchParams(window.location.search);
          newParams.delete("recruiterId");
          const newQuery = newParams.toString();
          const newUrl = `${window.location.pathname}${
            newQuery ? `?${newQuery}` : ""
          }${window.location.hash}`;
          window.history.replaceState(null, "", newUrl);
          window.location.reload();
        } catch (_) {}
      }
    };

    run();
  }, [UserStore]);

  return null;
}
